
export function getTextAreaFontSize(mobile, value) {
    // 16px because otherwise Safari zooms in everything on mobile
    if (mobile) {
        return Math.max(16, value);
    }
    return value;
}